export default __webpack_public_path__ + "static/media/index.9ee82284.less";